// Centralized API endpoint constants
export const API_BASE = '/api/v1/feedback';

export const ENDPOINTS = {
  SELF_APPRAISAL: `${API_BASE}/self_appraisal`,
  NOMINATION: `${API_BASE}/nomination`,
  NOMINATION_DETAILS: `${API_BASE}/nomination/details`,
  ADMIN_EMPLOYEE_LIST: `${API_BASE}/admin/employee/list/`,
  ADMIN_UPLOAD: `${API_BASE}/admin/upload/`,
  APPRAISAL_CYCLE: `${API_BASE}/appraisal_cycle/`,
};

export default ENDPOINTS;
